import { TFunction } from 'i18next';

const isEmpty = (value: unknown) => value === null || value === undefined || value === '';

/** `transactionType` reads as "Transaction type"; the keys are the audited fields' names. */
const fieldLabel = (key: string) => {
  const words = key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/**
 * One line per field the event changed. A value set where there was none reads as just the new
 * value, and one cleared as removed, rather than as a change from or to a dash.
 */
export const describeChanges = (
  before: Record<string, unknown>,
  after: Record<string, unknown>,
  t: TFunction,
): { key: string, text: string }[] => {
  const keys = [...new Set([...Object.keys(before), ...Object.keys(after)])];
  return keys
    .filter((key) => JSON.stringify(before[key]) !== JSON.stringify(after[key]))
    .map((key) => {
      const field = fieldLabel(key);
      const [from, to] = [before[key], after[key]];
      if (isEmpty(from)) {
        return { key, text: t($ => $.pointsAudit.changes.set, { field, value: String(to) }) };
      }
      if (isEmpty(to)) {
        return { key, text: t($ => $.pointsAudit.changes.removed, { field, value: String(from) }) };
      }
      return {
        key,
        text: t($ => $.pointsAudit.changes.changed, { field, from: String(from), to: String(to) }),
      };
    });
};
